export default __webpack_public_path__ + "static/media/logoutIcon.d940a37d.svg";